<template>
<v-container fluid>
	<div v-if="segments.length">
		<!--segments tab--><!--table head-->			
		<v-row class="mt-2 total" no-gutters>
			<v-col class="tabCell" v-for="item in headers"
				:key="item">{{item}}
			</v-col>
		</v-row>
		<v-row v-for="segment in segments" :key="segment.id" no-gutters>
			<v-col class="tabCell text-truncate">{{ segment.name }}</v-col>
			<v-col class="tabCell">{{ segment.designClassic }}</v-col>
			<v-col class="tabCell">{{ segment.designBusiness }}</v-col>
			<v-col class="tabCell">{{ segment.designCasual }}</v-col>
			<v-col class="tabCell">{{ segment.designInnovative }}</v-col>
			<v-col class="tabCell">{{ segment.designArt }}</v-col>
			<v-col class="tabCell">{{ segment.designLevel1 }}</v-col>
			<v-col class="tabCell">{{ segment.designLevel2 }}</v-col>
			<v-col class="tabCell">{{ segment.designLevel3 }}</v-col>
			<v-col class="tabCell">{{ segment.designLevel4 }}</v-col>
			<v-col class="tabCell">{{ segment.designLevel5 }}</v-col>
			<v-col class="tabCell">
				<change-design :segment="segment" 
					:gameId="gameId"
					:round="round">
				</change-design>
				<delete-segment :segment="segment" 
					:gameId="gameId"
					:round="round">
				</delete-segment>
			</v-col>
		</v-row>
	</div>		
</v-container>
</template>
<script>
	import changeDesign from './modal/changeDesign.vue'
	import deleteSegment from './modal/deleteSegment.vue'
		
	export default {
		props: ['gameId', 'round'],
		data (){
			return {
				headers: ['Segment', 'Classic design', 'Business design', 'Casual design', 'Innovative design', 'Art design','Design level 1', 'Design level 2', 'Design level 3', 'Design level 4', 'Design level 5', 'Action']
			}
		},		
		computed: {
			segments () {
				return this.$store.getters.segments
			}
		},
		methods: {
		},
		components: {
			changeDesign,
			deleteSegment
		}
	}
</script>